const NotificationTypes = {
  SUCCESS: "Success",
  ERROR: "Error",
  INFO: "Info",
  WARNING: "Warning"
}
export default NotificationTypes;
